/* BILLY × ARCHIE — Homepage JS (packs + ATC + before/after + testimonials carousel) */
(function(){
  'use strict';
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  function fmt(c){return (c/100).toFixed(2).replace('.',',')+' €';}

  document.addEventListener('DOMContentLoaded', function(){

    // Pack selection
    var rows = $$('.archie-home .pack-row');
    var atcTotal = $('#home-atc-total');
    function selectRow(row){
      rows.forEach(function(r){r.classList.remove('is-selected');});
      row.classList.add('is-selected');
      var inp = row.querySelector('.pack-radio-input');
      if(inp) inp.checked = true;
      refreshATC();
    }
    function refreshATC(){
      var row = $('.archie-home .pack-row.is-selected');
      if(!row) return;
      var qty = parseInt(row.dataset.quantity,10) || 1;
      var discount = parseFloat(row.dataset.discount) || 0;
      var priceEl = row.querySelector('.pack-row-price');
      var text = priceEl ? priceEl.textContent.trim() : '';
      if(atcTotal) atcTotal.textContent = text;
    }
    rows.forEach(function(row){
      row.addEventListener('click', function(){ selectRow(row); });
      var inp = row.querySelector('.pack-radio-input');
      if(inp) inp.addEventListener('change', function(){ selectRow(row); });
    });

    // Teinte picker
    var picker = $('#home-teinte-picker');
    var swatches = $$('.archie-home .teinte-swatch');
    var teinteName = $('#home-teinte-name');
    var selectedVariant = null;
    swatches.forEach(function(sw){
      sw.addEventListener('click', function(e){
        e.stopPropagation();
        if(sw.disabled) return;
        swatches.forEach(function(o){ o.classList.remove('is-active'); o.setAttribute('aria-checked','false'); });
        sw.classList.add('is-active'); sw.setAttribute('aria-checked','true');
        selectedVariant = sw.dataset.id;
        if(teinteName){ teinteName.textContent = sw.dataset.name; teinteName.classList.add('is-set'); }
        if(picker) picker.classList.remove('is-error');
      });
    });

    // ATC submit (ajax)
    var form = $('#archie-home-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var row = $('.archie-home .pack-row.is-selected');
        if(!row) return;
        var qty = parseInt(row.dataset.quantity,10) || 1;
        var variantId = selectedVariant;
        if(!variantId){
          if(picker){
            picker.classList.remove('is-error'); void picker.offsetWidth; picker.classList.add('is-error');
            picker.scrollIntoView({behavior:'smooth', block:'center'});
          }
          if(teinteName) teinteName.textContent = 'choisissez votre teinte';
          return;
        }
        var items = [];
        for(var i=0; i<qty; i++){ items.push({id: parseInt(variantId,10), quantity: 1}); }
        var btn = form.querySelector('button[type="submit"]');
        var orig = btn ? btn.innerHTML : '';
        if(btn){ btn.disabled = true; btn.innerHTML = 'Ajout en cours…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items: items})
        }).then(function(r){
          if(!r.ok) throw new Error('cart');
          return r.json();
        }).then(function(){
          window.location = '/cart';
        }).catch(function(){
          if(btn){ btn.disabled = false; btn.innerHTML = orig; }
          alert("Impossible d'ajouter au panier, réessayez.");
        });
      });
    }

    // Before/After slider
    var baSlider = $('#ba-slider-home');
    var baContainer = $('#ba-container-home');
    if(baSlider && baContainer){
      baSlider.addEventListener('input', function(e){
        baContainer.style.setProperty('--position', e.target.value + '%');
      });
    }

    // Testimonials carousel
    var tr = $('#home-testi-rail');
    var tp = $('#home-testi-prev');
    var tn = $('#home-testi-next');
    if(tr){
      function step(){ var c = tr.querySelector('.testimonial-card'); return c ? c.offsetWidth + 20 : 360; }
      function upd(){
        if(tp){ tp.disabled = tr.scrollLeft <= 4; }
        if(tn){ var m = tr.scrollWidth - tr.clientWidth - 4; tn.disabled = tr.scrollLeft >= m; }
      }
      if(tp) tp.addEventListener('click', function(){ tr.scrollBy({left: -step(), behavior: 'smooth'}); });
      if(tn) tn.addEventListener('click', function(){ tr.scrollBy({left: step(), behavior: 'smooth'}); });
      tr.addEventListener('scroll', upd);
      window.addEventListener('resize', upd);
      upd();
    }

    // Sticky mobile bar
    var sticky = $('#home-sticky-atc');
    if(sticky && 'IntersectionObserver' in window){
      var hide = {};
      var targets = [$('.archie-home .hero'), $('#packs'), $('.archie-home .final-cta'), $('footer')].filter(Boolean);
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ hide[targets.indexOf(en.target)] = en.isIntersecting; });
        var anyVisible = Object.keys(hide).some(function(k){ return hide[k]; });
        sticky.classList.toggle('is-visible', !anyVisible);
        sticky.setAttribute('aria-hidden', anyVisible ? 'true' : 'false');
      }, {threshold: 0});
      targets.forEach(function(t){ io.observe(t); });
    }

    // Init
    refreshATC();
  });
})();
